import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_flag_value = _resolveComponent("flag-value");
  const _component_value_element = _resolveComponent("value-element");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    styles: $props.styles,
    classes: "marketplace-value",
    gap: $props.gap
  }, {
    default: _withCtx(() => [_createVNode(_component_flag_value, {
      flag: $props.flag
    }, null, 8, ["flag"]), _ctx.$slots.value ? _renderSlot(_ctx.$slots, "value", {
      key: 0,
      value: $options.formattedValue
    }, undefined, true) : (_openBlock(), _createBlock(_component_value_element, {
      key: 1,
      id: "marketplace",
      value: $options.formattedValue
    }, null, 8, ["value"]))]),
    _: 3
  }, 8, ["styles", "gap"]);
}